import { useCallback } from "react"
import { useSignal } from "@preact/signals-react"
import { useToastSeeker } from "@ui-seeker/app"
import { deleteSubmit, getSubmit, postSubmit } from "@ui-seeker/utils"

import { BACKEND_APIS, SERVICES_TYPE } from "@constants"
import { isLoadingUserSettingSitesData, userSettingSitesData, userSettingSitesFormData, isEditUserSettingsSitesDrawer } from "../@signals"


export default function useUserSettingsSite(rowData={}) {
	const { showToast } = useToastSeeker()
	const isLoading = useSignal(false)

	const getSitesData = useCallback(() => {
		getSubmit(`${BACKEND_APIS.CRUD}/user/site_color`)
			.then(data => userSettingSitesData.value = data)
			.catch(() => {
				showToast.error()
				userSettingSitesData.value = []
			}).finally(() => isLoadingUserSettingSitesData.value = false)
	}, [])

	const handleSetSitesFormData = useCallback(() => userSettingSitesFormData.value = {
		id: rowData.id || null,
		color: rowData.color,
		id_site: rowData.id_site || null,
		service_type: SERVICES_TYPE.SITE_COLOR
	}, [JSON.stringify(rowData)])

	const handleChangeSitesFormData = useCallback((newValue, prop) => userSettingSitesFormData.value = {
		...userSettingSitesFormData.value,
		[prop]: newValue
	}, [])

	const handleSubmitSitesFormData = useCallback(() => {
		isLoading.value = true
		postSubmit(`${BACKEND_APIS.CRUD}/${!isEditUserSettingsSitesDrawer.value ? 'add' : 'update'}`, userSettingSitesFormData.value).then(res => {
			if (isEditUserSettingsSitesDrawer.value) {
				userSettingSitesData.value = [
					...userSettingSitesData.value.map(item => item.id === userSettingSitesFormData.value.id ? res : item)
				]
			} else {
				userSettingSitesData.value = [
					...userSettingSitesData.value,
					res
				]
			}
			userSettingSitesFormData.value = {}
		}).catch(() => showToast.error())
			.finally(() => isLoading.value = false)
	}, [])

	const handleDeleteSites = useCallback(() => showToast.confirm(`Are you sure you want to delete this row? This action cannot be undone.`, {
		onSubmit: () => {
			isLoading.value = true
			deleteSubmit(`${BACKEND_APIS.CRUD}/delete/${SERVICES_TYPE.SITE_COLOR}?id=${rowData.id}`).then(() => {
				userSettingSitesData.value = [
					...userSettingSitesData.value.filter(item => item.id !== rowData.id)
				]
			}).catch(() => showToast.error())
				.finally(() => isLoading.value = false)
		}
	}), [JSON.stringify(rowData)])

	return {
		isClicked: rowData.id === userSettingSitesFormData.value.id,
		isLoading: isLoading.value,
		getSitesData,
		handleSetSitesFormData,
		handleChangeSitesFormData,
		handleSubmitSitesFormData,
		handleDeleteSites
	}
}